import React, { useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import "./css/style.css";
import Master from "../Master";
import Overview from "./tabs/Overview";
import BasicDetails from "./tabs/BasicDetails";
import AcademicDetails from "./tabs/AcademicDetails";
import BatchAndFees from "./tabs/BatchAndFees";
import FeeTransactions from "./tabs/FeeTransactions";
import Attendance from "./tabs/Attendance";
import MarkReport from "./tabs/MarkReportV2";
import Hostel from "./tabs/Hostel";
import Library from "./tabs/Library";
import Transport from "./tabs/Transport";
import { useLocation, useNavigate } from "react-router-dom";
import StudentProfileHero from "./components/StudentProfileHero";
import StudentAdmissionForm from "./tabs/StudentAdmissionForm";
import StudentDemoForm from "./tabs/StudentDemoForm";
import BatchAndFeesDeleted from "./tabs/BatchAndFeesDeleted";
import usePrivateLink from "../../config/usePrivateLink";

/* ─── Main Component ─────────────────────────────────────────────────── */
export default function StudentDetailsV5() {
  const hasAccess = usePrivateLink();
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const id = params.get("id") ?? "";
  const activeTab = params.get("tab") || "Overview";

  const tabs = [
    {
      key: "Overview",
      icon: "ri-dashboard-line",
      title: "Overview",
      color: "primary",
      route: "/student/overview",

    },
    {
      key: "Basic",
      icon: "ri-user-3-line",
      title: "Basic Details",
      color: "success",
      route: "/student/details",

    },
    {
      key: "Academic",
      icon: "ri-graduation-cap-line",
      title: "Academic Details",
      color: "info",
      route: "/student/details",

    },
    {
      key: "Fees",
      icon: "ri-wallet-3-line",
      title: "Batch & Fees",
      color: "warning",
      route: "/student/batch/and/fees",
    },
    {
      key: "Payments",
      icon: "ri-money-rupee-circle-line",
      title: "Fee Transactions",
      color: "danger",
      route: "/student/fee/ransactions",
    },
    {
      key: "Attendance",
      icon: "ri-calendar-check-line",
      title: "Attendance",
      color: "primary",
      route: "/student/attendance",
    },
    {
      key: "Marks",
      icon: "ri-bar-chart-grouped-line",
      title: "Mark Report",
      color: "success",
      route: "/student/mark/report",
    },
    {
      key: "Hostel",
      icon: "ri-hotel-bed-line",
      title: "Hostel",
      color: "info",
      route: "/student/hostel",
    },
    {
      key: "Library",
      icon: "ri-book-open-line",
      title: "Library",
      color: "warning",
      route: "/student/library",
    },
    {
      key: "Bus",
      icon: "ri-bus-2-line",
      title: "Transport",
      color: "danger",
      route: "/student/transport",
    },
    {
      key: "Admission",
      icon: "ri-file-text-line",
      title: "Admission Form",
      color: "secondary",
      route: "/student/admission/form",
    },
    {
      key: "Demo",
      icon: "ri-clipboard-line",
      title: "Demo Form",
      color: "dark",
      route: "/student/demo/form",
    },
    {
      key: "BatchAndFeesDeleted",
      icon: "ri-delete-bin-line",
      title: "Deleted Batches & Fees",
      color: "danger",
      route: "/student/deleted/batches/Fees",
    },
  ];
  const filteredTabs = tabs.filter((tab) => hasAccess(tab.route));

  const handleTabChange = (tabKey) => {
    const newParams = new URLSearchParams(location.search);
    newParams.set("tab", tabKey);
    navigate(`${location.pathname}?${newParams.toString()}`, {
      replace: true,
    });
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row g-2">
                  <Master />
                  <div className="col-12">
                    <StudentProfileHero id={id} />

                    {/* ── Colorful Tabs ────────────────────────────────── */}
                    <div className="card border-0 shadow-sm rounded-3 mb-4">
                      <div className="card-body px-1 py-0">
                        <ul className="nav nav-pills flex-nowrap overflow-auto gap-2 pb-4 p-2">
                          {filteredTabs.map((tab) => {
                            const isActive = activeTab === tab.key;

                            return (
                              <li className="nav-item" key={tab.key}>
                                <button
                                  className={`tab-pill nav-link rounded-pill py-2 px-3 fw-semibold text-12px ${isActive
                                    ? `bg-${tab.color} text-white shadow`
                                    : `bg-light text-${tab.color} border-${tab.color}`
                                    }`}
                                  onClick={() => handleTabChange(tab.key)}
                                >
                                  <i className={`${tab.icon} ri-14px me-2`}></i>
                                  {tab.title}
                                </button>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>

                    {activeTab === "Overview" ? (
                      <Overview id={id} />
                    ) : activeTab === "Basic" ? (
                      <BasicDetails id={id} />
                    ) : activeTab === "Academic" ? (
                      <AcademicDetails id={id} />
                    ) : activeTab === "Attendance" ? (
                      <Attendance id={id} />
                    ) : activeTab === "Admission" ? (
                      <StudentAdmissionForm id={id} />
                    ) : activeTab === "Demo" ? (
                      <StudentDemoForm id={id} />
                    ) : activeTab === "Payments" ? (
                      <FeeTransactions id={id} />
                    ) : activeTab === "Fees" ? (
                      <BatchAndFees id={id} />
                    ) : activeTab === "Marks" ? (
                      <MarkReport id={id} />
                    ) : activeTab === "Bus" ? (
                      <Transport id={id} />
                    ) : activeTab === "Library" ? (
                      <Library id={id} />
                    ) : activeTab === "Hostel" ? (
                      <Hostel id={id} />
                    ) : activeTab === "BatchAndFeesDeleted" ? (
                      <BatchAndFeesDeleted id={id} />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
